import React from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import "../components/componentstyle/footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer text-white py-5 mt-4">
      <div className="container">
        <div className="row">
          {/* Left Column */}
          <div className="col-md-4 mb-4">
            {/* <h5 className="footer-title">SOLID EXPORTS</h5> */}
            <p>
              Cereals and pulses are one of the main elements in Indian foods.
              Indian food have been well-known over the world for their
              exceptional flavor, aroma, and excellent taste. We at Solid export
              believe that Indian culture and our extraordinary food variety
              should reach every side of the world.
            </p>
          </div>

          {/* Middle Column */}
          <div className="col-md-4 mb-4 ">
            <h5 className="footer-title">INFORMATION</h5>
            <div className="links">
              <div className="footer-links">
                <Link to="/about">
                  <span>&#8250;</span> About
                </Link>
                {/* <Link to="/event">
                  <span>&#8250;</span> Recent Event
                </Link> */}
              </div>
              <hr />
              <div className="footer-links">
                {/* <Link to="/import">
                  <span>&#8250;</span> Import
                </Link> */}
                <Link to="/gellery">
                  <span>&#8250;</span> Gallery
                </Link>
              </div>
              <hr />
              <div className="footer-links">
                <Link to="/export">
                  <span>&#8250;</span> Export
                </Link>
                {/* <Link to="/contact">
                  <span>&#8250;</span> Contact Us
                </Link> */}
              </div>
              <hr />
              <div className="footer-links">
                <Link to="/contact">
                  <span>&#8250;</span> Contact Us
                </Link>
              </div>
              <hr />  
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-4 mb-4">
            <h5 className="footer-title">ADDRESS INFO</h5>
            <div className="footer-contact">
              <div className="footer-address d-flex">
                <FaMapMarkerAlt className="footer-icon" />
                <div className="title">
                  <p>ADDRESS</p>
                  <p>
                    Surat , India
                  </p>
                </div>
              </div>
              <hr />
              <div className="footer-address d-flex pt-3">
                <FaPhoneAlt className="footer-icon" />
                <div className="title">
                  <p>PHONE</p>
                  <p>+91 7096000699</p> <p>+91 9712020601</p>
                  <p>+91 9558366896</p>
                </div>
              </div>
              <hr />
              <div className="footer-address d-flex pt-3">
                <FaEnvelope className="footer-icon" />
                <div className="title">
                  <p>EMAIL</p>
                  <p>jmcdist.surat@gmail.com</p>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
